<script>
import formatDateMixin from '@/mixins/formatDateMixin'
import { isWorkingTowardsQual } from '@/helpers/candidate-details-helpers'

export default {
  name: 'CandidateQualificationListItem',
  mixins: [formatDateMixin],
  props: {
    qualification: {
      type: Object,
      required: true,
    },
    timeZone: {
      type: String,
      default: null,
    },
  },
  computed: {
    completionDate() {
      if (isWorkingTowardsQual(this.qualification))
        return this.$t('candidateDetailsPopup.qualification.inProgress')

      const date = this.qualification?.completedUTC
      if (!date) return null
      return this.$t('candidateDetailsPopup.details.qualification.obtainedOn', {
        date: this.renderI18nFormattedDate(
          date,
          this.timeZone,
          'dateFormattedLong'
        ),
      })
    },
  },
}
</script>

<template>
  <v-sheet
    class="candidate-qualification-list-item d-flex justify-space-between align-start pa-4"
    outlined
    rounded="xl"
  >
    <div>
      <p class="text-md-bold text-capitalize">{{
        (qualification.institute || '').toLowerCase()
      }}</p>
      <p class="text-md">{{ qualification.degree }}</p>
      <p
        class="text-md mb-0"
        :class="{
          'font-italic':
            completionDate ===
            $t('candidateDetailsPopup.qualification.inProgress'),
        }"
      >
        {{ completionDate || '—' }}
      </p>
    </div>
  </v-sheet>
</template>
